const STORAGE_KEY_PREFIX = 'black_peak_validation_lab_results_v1';
const STORAGE_VERSION = 1;

function getStorage() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  return window.localStorage;
}

export function getValidationLabResultsStorageKey(userId) {
  if (userId === null || userId === undefined || userId === '') {
    return null;
  }

  return `${STORAGE_KEY_PREFIX}:${String(userId)}`;
}

export function loadValidationLabResults(userId) {
  const storage = getStorage();
  const key = getValidationLabResultsStorageKey(userId);
  if (!storage || !key) {
    return null;
  }

  try {
    const raw = storage.getItem(key);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== STORAGE_VERSION || typeof parsed !== 'object') {
      storage.removeItem(key);
      return null;
    }

    return parsed;
  } catch (_error) {
    return null;
  }
}

export function saveValidationLabResults(userId, snapshot) {
  const storage = getStorage();
  const key = getValidationLabResultsStorageKey(userId);
  if (!storage || !key) {
    return false;
  }

  try {
    storage.setItem(key, JSON.stringify({ ...snapshot, version: STORAGE_VERSION }));
    return true;
  } catch (_error) {
    return false;
  }
}

export function clearValidationLabResults(userId) {
  const storage = getStorage();
  const key = getValidationLabResultsStorageKey(userId);
  if (!storage || !key) {
    return;
  }

  try {
    storage.removeItem(key);
  } catch (_error) {
    // Storage can be unavailable or quota-restricted; clearing is best effort.
  }
}
